import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style } from "../../styles/Style";
import Action from "../../components/Action";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp.js";
import changeMonthToText from "../../utils/ChangeMonthToText";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";
import { beneficiaryStatus } from "../../utils/DataSource";
import ContentLoader from "react-content-loader";
import {
  createBeneficiary,
  deleteBeneficiary,
  getBeneficiries,
  updateBeneficiary,
} from "../../store/actions/BenActions";
import DownloadBtn from "../../components/DownloadBtn";
import { currentDate } from "../../utils/currentDate";
import { useSelector } from "react-redux";
function Beneficiries() {
  // beneficiary
  const [beneficiary, setBeneficiary] = useState({
    id: "",
    beneficiaryCode: "",
    birthDate: "",
    firstName: "",
    gender: "",
    lastName: "",
    registeredDate: "",
    status: "",
  });
  // overlay for adding beneficiries
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    dispatch({
      type: "REGISTER_BENEFICIARY_FAILED",
      registerBenActionFailedMessage: "",
    });
    setBeneficiary({
      id: "",
      beneficiaryCode: "",
      birthDate: "",
      firstName: "",
      gender: "",
      lastName: "",
      registeredDate: "",
      status: "",
    });
    setAddBeneOverlay(!addBenOverlay);
  }
  // overlay for filtering beneficiries
  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  // overlay for editting beneficiary profile
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedBeneficiary) {
    dispatch({
      type: "REGISTER_BENEFICIARY_FAILED",
      registerBenActionFailedMessage: "",
    });
    setEditBeneOverlay(!editBenOverlay);
    setBeneficiary({
      id: passedBeneficiary.id,
      beneficiaryCode: passedBeneficiary.beneficiaryCode,
      birthDate: changeFromTimeStamp(new Date(passedBeneficiary.birthDate)),
      firstName: passedBeneficiary.firstName,
      gender: passedBeneficiary.gender,
      lastName: passedBeneficiary.lastName,
      registeredDate: changeFromTimeStamp(
        new Date(passedBeneficiary.registeredDate)
      ),
      status: passedBeneficiary.status,
    });
  }

  const dispatch = useDispatch();

  // table columns
  const beneficiriesColumns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "BenId",
        accessor: "benId",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Birthdate",
        accessor: "birthDate",
      },
      {
        Header: "Status",
        accessor: "benStatus",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );
  const loaders = useSelector((state) => state.loadersState);
  const benefs = useSelector((state) => state.beneficiries);
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function closeFormAfterAdding() {
    benOverlayController();
    setBeneficiary({
      id: "",
      beneficiaryCode: "",
      birthDate: "",
      firstName: "",
      gender: "",
      lastName: "",
      registeredDate: "",
      status: "",
    });
  }

  function closeFormAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryCode: "",
      birthDate: "",
      firstName: "",
      gender: "",
      lastName: "",
      registeredDate: "",
      status: "",
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (beneficiary.id) {
      const id = beneficiary.id;
      const updatedBeneficiary = {
        beneficiaryCode: beneficiary.beneficiaryCode,
        birthDate: beneficiary.birthDate,
        firstName: beneficiary.firstName,
        gender: beneficiary.gender,
        lastName: beneficiary.lastName,
        registeredDate: beneficiary.registeredDate,
        status: beneficiary.status,
      };
      dispatch(
        updateBeneficiary(updatedBeneficiary, id, closeFormAfterUpdating)
      );
    } else {
      const newBeneficiary = {
        ...beneficiary,
        registeredDate: new Date(),
      };
      dispatch(createBeneficiary(newBeneficiary, closeFormAfterAdding));
    }
  };

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteBeneficiary(id));
  };
  // transforming results
  let [loadedBeneficiaries, setBeneficiries] = useState([]);
  useEffect(() => {
    setBeneficiries([]);
    for (let i = 0; i < benefs.length; i++) {
      const ourBeneficary = {
        count: i + 1,
        id: benefs[i].id,
        benId: benefs[i].beneficiaryCode,
        name: `${benefs[i].firstName} ${benefs[i].lastName}`,
        gender: capitalizeFirstLetter(benefs[i].gender),
        birthDate: (
          <p className="fit-content">
            {changeMonthToText(benefs[i].birthDate)}
          </p>
        ),
        benStatus: (
          <div className={"py-1 px-2 rounded   fit-content flex"}>
            <p>{capitalizeFirstLetter(benefs[i].status)}</p>
          </div>
        ),
        action: (
          <Action
            editAction={() => {
              editOverlayController(benefs[i]);
            }}
            deleteAction={() => {
              handleDelete(benefs[i].id, i);
            }}
          />
        ),
      };

      setBeneficiries((loadedBeneficiaries) => [
        ...loadedBeneficiaries,
        ourBeneficary,
      ]);

      if (loaders.deletingBen.deleting) {
        const currentBenefs = loadedBeneficiaries;
        const newData = currentBenefs.map((beneficiary) =>
          beneficiary.id === loaders.deletingBen.id
            ? {
              ...beneficiary,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : beneficiary
        );
        setBeneficiries(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benefs, loaders.deletingBen.deleting]);


  let [loadingBeneficiaries, setLoadingBeneficiries] = useState([]);

  useEffect(() => {
    setLoadingBeneficiries([]);
    for (let i = 0; i < 5; i++) {
      const ourBeneficary = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        benId: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 70 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="60" height="7" />
          </ContentLoader>
        ),
        name: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 100 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="90" height="7" />
          </ContentLoader>
        ),
        gender: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 90 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="80" height="7" />
          </ContentLoader>
        ),
        birthDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 100 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="90" height="7" />
          </ContentLoader>
        ),
        benStatus: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 80 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="70" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 90 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="80" height="7" />
          </ContentLoader>
        ),
      };

      setLoadingBeneficiries((loadingBeneficiaries) => [
        ...loadingBeneficiaries,
        ourBeneficary,
      ]);
    }
  }, [loaders.fetchingBeneficiriesLoaders]);


  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="bg-white mx-10">
        <div className="flex flex-col md:flex-row p-10 pt-5  pb-0">
          <h2 className="font-semibold">Beneficiries Account</h2>
          <div className="mt-2 md:m-auto md:mr-0">
            <button
              className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-170 title-tip"
              onClick={() => {
                benOverlayController();
              }}
              message="Register"
            >
              <AiOutlineUserAdd />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-40 hover:bg-gray-100 title-tip"
              onClick={() => {
                filterOverlayController();
              }}
              message="Filter"
            >
              <FiFilter />
            </button>

            <button
              className={
                "p-2 mr-2 rounded text-gray-500 border border-gray-40 hover:bg-gray-100 title-tip"
              }
              message="Refresh"
              onClick={() => {
                dispatch(getBeneficiries());
              }}
            >
              <FcRefresh
                className={
                  loaders.fetchingBeneficiriesLoaders ? " refresh-loader" : " "
                }
              />
            </button>

            <DownloadBtn
              filename={`beneficiaries-${changeMonthToText(currentDate())}`} table="table-to-xls"
            />

          </div>
        </div>
        <div className="md:pb-5 ml-10 mr-10 border-gray-40" />
        <div className="pb-5 px-0 pr-10  flex flex-wrap  w-full">
          {/* beneficiries table */}
          <div className="w-full">
            {!loaders.fetchingBeneficiriesLoaders &&
              loadedBeneficiaries.length < 1 ? (
              <div
                className={
                  !loaders.fetchingBeneficiriesErroredMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.fetchingBeneficiriesErroredMessage
                    ? "No beneficiary record found"
                    : loaders.fetchingBeneficiriesErroredMessage}
                </p>
              </div>
            ) : (
              <Table
                data={
                  loaders.fetchingBeneficiriesLoaders
                    ? loadingBeneficiaries
                    : loadedBeneficiaries
                }
                columns={beneficiriesColumns}
              />
            )}
          </div>
        </div>
        {/*add beneficiary overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.registerBenActionFailedMessage
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.registerBenActionFailedMessage}</p>
              </div>
              <div className="p-10">
                {/* register beneficiary header */}
                <div className="flex">
                  <h2 className="font-semibold my-2 w-80">
                    {addBenOverlay
                      ? "Register beneficiary"
                      : "Change beneficiary info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                            beneficiaryCode: "",
                            birthDate: "",
                            firstName: "",
                            gender: "",
                            lastName: "",
                            registeredDate: "",
                            status: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                {/* register beneficiary form */}
                <form className="flex flex-col" onSubmit={handleSubmit}>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Beneficiary Id </label>
                    <div className={style.field.parentDiv}>
                      <input
                        type="text"
                        className={style.field.input}
                        value={beneficiary.beneficiaryCode}
                        onChange={(e) =>
                          setBeneficiary({
                            ...beneficiary,
                            beneficiaryCode: e.target.value.toUpperCase(),
                          })
                        }
                      />
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Fist name </label>
                    <div className={style.field.parentDiv}>
                      <input
                        type="text"
                        className={style.field.input}
                        value={beneficiary.firstName}
                        onChange={(e) =>
                          setBeneficiary({
                            ...beneficiary,
                            firstName: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Last Name </label>
                    <div className={style.field.parentDiv}>
                      <input
                        type="text"
                        className={style.field.input}
                        value={beneficiary.lastName}
                        onChange={(e) =>
                          setBeneficiary({
                            ...beneficiary,
                            lastName: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Birthdate </label>
                    <div className={style.field.parentDiv}>
                      <input
                        type="date"
                        className={style.field.input}
                        value={beneficiary.birthDate}
                        onChange={(e) =>
                          setBeneficiary({
                            ...beneficiary,
                            birthDate: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Status </label>
                    <Select
                      options={beneficiaryStatus}
                      value={beneficiaryStatus.find(
                        (obj) => obj.value === beneficiary.status
                      )}
                      onChange={(e) =>
                        setBeneficiary({
                          ...beneficiary,
                          status: e.value,
                        })
                      }
                    />
                  </div>
                  {/* gender */}
                  <div className="flex">
                    <span className="text-gray-500 mr-2">Gender</span>
                    <div className="flex flex-row">
                      <div className="mr-2">
                        <label className="items-cente flex">
                          <input
                            type="radio"
                            className="form-radio m-auto"
                            name="gender"
                            value="MALE"
                            checked={beneficiary.gender === "MALE"}
                            onChange={(e) =>
                              setBeneficiary({
                                ...beneficiary,
                                gender: e.target.value,
                              })
                            }
                          />
                          <span className="ml-2 m-auto">Male</span>
                        </label>
                      </div>
                      <div>
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            className="form-radio m-auto"
                            name="gender"
                            value="FEMALE"
                            checked={beneficiary.gender === "FEMALE"}
                            onChange={(e) =>
                              setBeneficiary({
                                ...beneficiary,
                                gender: e.target.value,
                              })
                            }
                          />
                          <span className="ml-2 m-auto">Female</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* save btn */}
                  <button
                    type="submit"
                    className={style.loginBtn}
                    disabled={loaders.sendingBenInfoLoader}
                  >
                    {!loaders.sendingBenInfoLoader ? (
                      <p className="m-auto">
                        {addBenOverlay ? "Save" : "Update"}
                      </p>
                    ) : (
                      <div className="spinner m-auto">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                      </div>
                    )}
                  </button>
                </form>
              </div>
              {/* end of form */}
            </div>
          </Overlay>
        </div>
        {/* filter beneficiries overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold my-2  w-80">
                  Filter beneficiries
                </h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Birthdate range</label>
                  <div className="flex">
                    <div className={style.field.parentDiv + "w-1/2 mr-2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                    <div className={style.field.parentDiv + "w-1/2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                  </div>
                </div>

                {/*  field */}
                <div className="py-2  w-full">
                  <label>Status </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/* gender */}
                <div className="flex flex-col">
                  <span className="text-gray-500 mr-4">Gender</span>
                  <div className="flex flex-row">
                    <div className="mr-2">
                      <label className="items-cente flex">
                        <input
                          type="radio"
                          className="form-radio m-auto"
                          name="radio"
                          value="2"
                        />
                        <span className="ml-2 m-auto">Female</span>
                      </label>
                    </div>
                    <div className="mr-2">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          className="form-radio m-auto"
                          name="radio"
                          value="3"
                        />
                        <span className="ml-2 m-auto">Male</span>
                      </label>
                    </div>
                    <div>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          className="form-radio m-auto"
                          name="radio"
                          value="3"
                        />
                        <span className="ml-2 m-auto">Both genders</span>
                      </label>
                    </div>
                  </div>
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">Apply</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary Id</th>
            <th>Name</th>
            <th>Gender</th>
            <th>Birth Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {benefs.map((ben) =>
            <tr>
              <td>{ben.beneficiaryCode}</td>
              <td>{ben.firstName}
                {ben.lastName}</td>
              <td>{ben.gender}</td>
              <td>{ben.birthDate}</td>
              <td>{ben.status}</td>
            </tr>
          )}
        </tbody>
      </table>
    </DashLayout>


  );
}

export default Beneficiries;
